angular.module('core')
  .directive('timeoutHandler', ['$rootScope', 'configuration', 'Idle', 'Keepalive', '$modal', function ($rootScope, $configuration, $idle, $keepalive, $modal) {
    return {
      restrict: 'A',
      link: function($scope, $element) {

        $idle.setIdle($configuration.getIdle().idle);
        $idle.setTimeout(Number($configuration.getIdle().timeout));

        var closeModals = function() {
          if ($scope.warning) {
            $scope.warning.close();
            $scope.warning = null;
          }
        };

        $scope.$on('IdleStart', function() {
          closeModals();
          $keepalive.stop();

          $scope.warning = $modal.open({
            templateUrl: 'resources/core/partials/timeout-modal-warning.html',
            windowClass: 'timeout-modal',
            controller: 'TimeoutModalController',
            backdrop: 'static',
            keyboard: false
          });
        });

        $scope.$on('IdleEnd', function() {
          closeModals();
        });

        $scope.$on('idleReset', function() {
          $idle.watch();
          $keepalive.start();
          closeModals();
        });

        $scope.$on('IdleTimeout', function() {
          // Too late.
          $rootScope.$broadcast('sessionExpired');
        });

        $rootScope.$on('KeepaliveResponse', function(event, data, status) {
          // log user out if status is no good
          if( Number(status) !== 200 ) {
            $rootScope.$broadcast('sessionExpired');
          }
        });
      }
    };
  }]);
